import type {
  ColumnActionOptions,
  ColumnSizingOptions,
  DashboardTableState,
} from '~shared/ui/dashboard-table';

import { ColumnId } from './columns';

export const defaultState: DashboardTableState<ColumnId> = {
  pagination: { page: 0, rowsPerPage: 10 },
};

export const defaultPagination = {
  page: 0,
  perPage: 10,
};

export const colSizingOptions: Record<ColumnId, ColumnSizingOptions> = {
  [ColumnId.SHOP_ORDER_ID]: { minWidth: 130, width: '15%' },
  [ColumnId.ORDER_NUMBER]: { minWidth: 120, width: '15%' },
  [ColumnId.ORDER_DATE]: { width: 120 },
  [ColumnId.CUSTOMER_NAME]: { minWidth: 130, width: '20%' },
  [ColumnId.STORE_NAME]: { minWidth: 200, width: '25%' },
  [ColumnId.ORDER_STATUS]: { minWidth: 100, width: '10%' },
  [ColumnId.ITEMS_NUMBER]: { width: 90 },
  [ColumnId.TOTAL_PRICE]: { minWidth: 100, width: '15%' },
};

export const colActionOptions: Record<ColumnId, ColumnActionOptions> = {
  [ColumnId.SHOP_ORDER_ID]: { isSortable: false },
  [ColumnId.ORDER_NUMBER]: { isSortable: false },
  [ColumnId.ORDER_DATE]: { isSortable: false },
  [ColumnId.CUSTOMER_NAME]: { isSortable: false },
  [ColumnId.STORE_NAME]: { isSortable: false },
  [ColumnId.ORDER_STATUS]: { isSortable: false },
  [ColumnId.ITEMS_NUMBER]: { isSortable: false },
  [ColumnId.TOTAL_PRICE]: { isSortable: false },
};
